import { Backend } from '@/_axios';

export default {
  search(name = '', id = null) {
    return Backend.get('/suppliers/search', { params: { name, id } });
  },
};
